import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import itemShadow from '../../assets/images/item_shadow.png';

const StyledGameContainer = styled.div`
	position: absolute;
	left: 50%;
	bottom: 40px;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const StyledTopContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 100px 1fr;
	gap: 70px;
	align-items: center;
	justify-items: center;
`;

const StyledNameContainer = styled.div<{ $direction: 'left' | 'right' }>`
	position: relative;
	height: 30px;

	${Text} {
		position: absolute;
		${(props) =>
			props.$direction === 'left' ? 'right: 10px;' : 'left: 10px;'};
		top: 50%;
		transform: translateY(-50%);
		font-weight: 700;
		font-size: 14px;
		line-height: 16px;
		color: #ffffff;
		white-space: nowrap;
		z-index: 2;
	}

	.bg {
		position: absolute;
		width: 140px;
		height: 30px;
		${(props) => (props.$direction === 'left' ? 'right: 0;' : 'left: 0;')};
		background: linear-gradient(90deg, rgba(17, 19, 20, 0) 0%, #111314 100%);
		border-radius: 10px;
		${(props) =>
			props.$direction === 'right' && 'transform: matrix(-1, 0, 0, 1, 0, 0);'};
	}
`;

const StyledTimerContainer = styled.div`
	display: grid;
	grid-template-columns: 16px 50px;
	gap: 10px;
	align-items: center;
	height: 30px;
	padding: 0 8px;
	background-color: #ffffff;
	border-radius: 10px;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
		filter: invert(100%);
	}

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #262628;
	}
`;

const StyledChooseContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 220px);
	gap: 10px;
	margin-top: 20px;
`;

const StyledChooseItem = styled.div<{ $active?: boolean }>`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 213px;
	background-color: ${(props) => (props.$active ? '#2D70D9' : '#111314')};
	border-radius: 10px;
	border: 1px solid
		${(props) =>
			props.$active ? 'rgba(255, 255, 255, 0.25)' : 'rgba(255, 255, 255, 0.1)'};
	transition:
		background-color 0.3s ease,
		border 0.3s ease;
	overflow: hidden;

	.icon {
		width: 50px;
		height: 50px;
		user-select: none;
		pointer-events: none;
		opacity: ${(props) => (props.$active ? 1 : 0.5)};
		transition: opacity 0.3s ease;
	}

	.dot {
		opacity: ${(props) => (props.$active ? 0.5 : 0)};
		transition: opacity 0.3s ease;
	}

	& > ${Text} {
		font-weight: 700;
		font-size: 20px;
		text-align: center;
		color: #ffffff;
		text-transform: uppercase;
		z-index: 2;
		margin-top: 20px;
	}
`;

const StyledItemShadow = styled.div`
	position: absolute;
	top: -200px;
	left: 50%;
	transform: translateX(-50%);
	width: 400px;
	height: 400px;
	background-image: url(${itemShadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	user-select: none;
	pointer-events: none;
`;

const StyledKeyContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 20px;
	margin-top: 30px;

	.dot {
		width: 2px;
		height: 2px;
		background: #ffffff;
		border-radius: 50%;
	}
`;

const StyledControlsContainer = styled.div`
	position: absolute;
	right: 40px;
	bottom: 40px;
	display: flex;
	justify-content: space-between;
`;

export {
	StyledChooseContainer,
	StyledChooseItem,
	StyledControlsContainer,
	StyledGameContainer,
	StyledItemShadow,
	StyledKeyContainer,
	StyledNameContainer,
	StyledTimerContainer,
	StyledTopContainer,
};
